<script>

	import { onMount, onDestroy } from 'svelte';
	
	import { account_service       , account_service_context_key        } from './_services/account.js';
   import { loggedIn                                                   } from './_services/accountsession.js';
	import { cookiejar_service     , cookiejar_service_context_key      } from './_services/cookiejar.js';
	
	let seconds = 0;
	const interval = setInterval(() => {seconds = seconds + 1;}, 1000);


	function handleBubbleUpMessage(event) {
		alert(event.detail.loggedIn);
	}
	
	
	onMount(async () => {

	});
		
	onDestroy(() => { 
		clearInterval(interval) 
	});

</script>

<style>


	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
/*		color: purple;    */
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
	
	#home_banner  {
	  width: 100%;
	  height: 300px;
/*	  padding: 20px;  */
	  
	  position: absolute;
	  top: 50%;
	  left: 50%; 
	
	  margin: -150px 0 0 -50%;  /* Using negative margins equal to half of that width and height */
	  
	}	
	
	#home_banner_img  {
	  width: 100%;
	  height: 300px;
	  border: 1px solid black;
	  
	  background-image: url('../assets/IbPqGZDsjzfChdM4.jpg');
	  background-size: cover;
	}	
		
	
	.spacer  {
	}	
 
</style>
 
<div id="home_banner">
	<p>Made by Humans, rather than Natural</p>
	<div id="home_banner_img"></div>
</div>

<!--
<h1>This is Home page</h1>
<p>It's been running for {seconds} seconds</p>
--->
